// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__26GOa","label":"Completed_label__JXsFS"};